import React from 'react';
import { CheckCircle } from '@finect/tabular-icons/checkCircle';
import { XCircle } from '@finect/tabular-icons/xCircle';
import { withTheme } from 'styled-components';
export var Boolean = withTheme(function (_ref) {
  var value = _ref.value,
    theme = _ref.theme;
  var Icon = value ? CheckCircle : XCircle;
  var color = value ? 'positive' : 'negative';
  return React.createElement(Icon, {
    color: theme.colors[color]
  });
});